import { render, staticRenderFns } from "./DiagnosticsDetailsPage.vue?vue&type=template&id=7401b177&scoped=true"
import script from "./DiagnosticsDetailsPage.vue?vue&type=script&lang=js"
export * from "./DiagnosticsDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticsDetailsPage.vue?vue&type=style&index=0&id=7401b177&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7401b177",
  null
  
)

export default component.exports